// Auth
export const AUTH_USER = 'auth_user'
export const UNAUTH_USER = 'unauth_user'
export const AUTH_ERROR = 'auth_error'
// All list
export const FETCH_MESSAGE = 'fetch_message'
export const MORE_MESSAGE = 'more_message'
// person single
export const FILTERPARAMS = 'filterparams'
export const FILTERPARAMS_SET = 'filterparams_set'
export const OPEN_PERSON = 'open_person'
export const CLOSE_PERSON = 'close_person'
export const PERSON_MERGE = 'person_merge'
// person select helper - get enums
export const GET_QUALIFICATION = 'get_qualification'
export const GET_QUALIFICATIONTYPES = 'get_qualificationtypes'
export const GET_FEETYPES = 'get_feetypes'
export const GET_MEMBERSHIP = 'get_membership'
export const GET_PERSONCATEGORIES = 'get_personcategories'
export const GET_AFFAIRCATEGORIES = 'get_affaircategories'
// person function
export const GET_NAMES = 'get_names'
// person - get related list
export const GET_FEES = 'get_fees'
export const GET_GROUPS = 'get_groups'
// fee single
export const OPEN_FEE = 'open_fee'
export const CLOSE_FEE = 'close_fee'
// autocomplete
export const GET_AUTOCOMPLETE = 'get_autocomplete'
export const GET_MOREAUTOCOMPLETE = 'get_moreautocomplete'
export const GET_AUTOCOMPLETE2 = 'get_autocomplete2'
export const GET_MOREAUTOCOMPLETE2 = 'get_moreautocomplete2'
export const GET_AUTOCOMPLETEAFFAIR = 'get_autocompleteaffair'
export const GET_AUTOCOMPLETE4 = 'get_autocomplete4'
export const GET_MOREAUTOCOMPLETE4 = 'get_moreautocomplete4'
export const GET_AUTOCOMPLETE5 = 'get_autocomplete5'
export const GET_MOREAUTOCOMPLETE5 = 'get_moreautocomplete5'
// tb
export const OPEN_AFFAIR = 'open_affair'
export const CLOSE_AFFAIR = 'close_affair'
export const GET_AFFAIRSTATUS = 'get_affairstatus'
export const GET_AFFAIRAUTOMATED = 'get_affairautomated'
// settings
export const OPEN_SETTING = 'open_setting'
export const CLOSE_SETTING = 'close_setting'
// groups
export const OPEN_GROUP = 'open_group'
export const CLOSE_GROUP = 'close_group'
export const GET_GROUPTYPES = 'get_grouptypes'
export const OPEN_GROUPREGISTRATIONFEE = 'get_groupregistrationfee'
export const GET_TRAININGSTATUS = 'get_trainingstatus'
// statistics
export const GET_GROUPSBYYEAR = 'get_groupsbyyear'
export const GET_GROUPSBYLESSONCOUNT = 'get_groupsbylessoncount'
export const GET_PARTICIPANTAMOUNTS = 'get_participantamounts'
export const GET_TOPLEADERS = 'get_topleaders'
export const GET_TOPLEADERSMORE = 'get_topleadersmore'

export const GET_FEEOVERVIEW = 'get_feeoverview'
export const GET_DEBITORSONEYEAR = 'get_debitorsoneyear'
export const GET_DEBITORSTWOYEAR = 'get_debitorstwoyear'
export const GET_DEBITORSONEYEARMORE = 'get_debitorsoneyearmore'
export const GET_DEBITORSTWOYEARMORE = 'get_debitorstwoyearmore'


// WEBPACK FOOTER //
// ./src/actions/types.js